import ContainerContent from "components/Container/ContainerContent";
import LeasingReportContract from "./report/leasing.reportContract";
import LeasingReportAging from "./report/leasing.agingReport";
import LeasingReportPayment from "./report/leasing.payment";
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";
import { useState } from "react";
import AutoMail from "../Leasing/report/leasing.autoMail";
import { DateTime } from "luxon";

const ReportGeneral = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  interestDate,
  setInterestDate,
}) => {
  return (
    <div className="col-span-1 rounded border-gray-100 shadow-sm px-4 py-3 border">
      <div className="flex flex-col">
        <h1 className="font-bold text-lg">Report General</h1>
        <div>
          วันที่ล่าสุดของข้อมูล (ถ้าไม่กำหนดวันที่จะใช้วันปัจจุบัน) วันเริ่มต้น
        </div>

        <div className="my-2">
          <div className="flex flex-col">
            <div>วันที่เริ่มต้น</div>
            <input
              value={startDate}
              type="date"
              className="p-2 border border-gray-200 mt-2 rounded-lg"
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="flex flex-col mt-2">
            <div>วันที่สิ้นสุด</div>
            <input
              value={endDate}
              type="date"
              className="p-2 border border-gray-200 mt-2 rounded-lg"
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="flex flex-col mt-2">
            <div>วันที่คิดดอกเบี้ย</div>
            <input
              value={interestDate}
              type="date"
              className="p-2 border border-gray-200 mt-2 rounded-lg"
              onChange={(e) => setInterestDate(e.target.value)}
            />
          </div>
        </div>

        <div className="flex flex-col mt-4">
          <LeasingReportContract
            startDate={startDate}
            endDate={endDate}
            interestDate={interestDate}
          />
        </div>
      </div>
    </div>
  );
};

const ReportSandbox = ({ sandboxDate, setSandboxDate }) => {
  return (
    <div className="col-span-1 rounded border-gray-100 shadow-sm px-4 py-3 border">
      <div className="flex flex-col">
        <h1 className="font-bold text-lg">Sandbox</h1>
        <div>เลือกวันที่</div>

        <div className="my-2">
          <div className="flex flex-col">
            <div>วันที่</div>
            <input
              value={sandboxDate}
              type="date"
              className="p-2 border border-gray-200 mt-2 rounded-lg"
              onChange={(e) => setSandboxDate(e.target.value)}
            />
          </div>
        </div>

        <div className="flex flex-col mt-2">
          <LeasingReportAging sandboxDate={sandboxDate} />
          <AutoMail
            sandboxDate={sandboxDate}
            typeCreate="ONE"
            texts={[
              `Interface Create One 8.05`,
              `(T = 0.00 - 8.04) (T + 1 = 16:31 - 23:59)`,
              `(T + 1 = ธนาคารอื่นๆ (BBL, KBANK, SCB, KTB)`,
            ]}
          />
          <AutoMail
            sandboxDate={sandboxDate}
            typeCreate="TWO"
            texts={[`Interface Create Two 13:35`, `(T = 8:05 - 13:34)`]}
          />
          <AutoMail
            sandboxDate={sandboxDate}
            typeCreate="THREE"
            texts={[`Interface Create Three 16:36`, `(T = 13:35 - 16:35)`]}
          />
        </div>
      </div>
    </div>
  );
};

const ReportByMonth = ({ month, setMonth }) => {
  return (
    <div className="col-span-1 rounded border-gray-100 shadow-sm px-4 py-3 border">
      <div className="flex flex-col">
        <h1 className="font-bold text-lg">Report Interface (By Month)</h1>
        <div>เลือกเดือน</div>

        <div className="my-2">
          <div className="flex flex-col">
            <input
              value={month}
              type="month"
              className="p-2 border border-gray-200 mt-2 rounded-lg"
              onChange={(e) => setMonth(e.target.value)}
            />
          </div>
        </div>

        <div className="flex flex-col mt-2">
          <LeasingReportPayment month={month} />
        </div>
      </div>
    </div>
  );
};

function LeasingReportMain() {
  const today = getCurrentLocalDateTime().fullDate;
  const [startDate, setStartDate] = useState(
    getCurrentLocalDateTime(new Date("2023-01-01")).fullDate
  );
  const [endDate, setEndDate] = useState(today);
  const [interestDate, setInterestDate] = useState(today);
  const [sandboxDate, setSandboxDate] = useState(today);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));

  return (
    <ContainerContent>
      <div className="grid grid-cols-4 ml-4">
        {/* Report Main */}
        <ReportGeneral
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          interestDate={interestDate}
          setInterestDate={setInterestDate}
        />
        <ReportByMonth month={month} setMonth={setMonth} />
        <ReportSandbox
          sandboxDate={sandboxDate}
          setSandboxDate={setSandboxDate}
        />
      </div>
    </ContainerContent>
  );
}

export default LeasingReportMain;
